





import Vue from 'vue';
import { SkladNovychVozu } from '@/modules/noveVozy/skladNovychVozu';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { types } from '../../store/types';
import { store } from '../../store/edit';

export default Vue.extend({
	name: 'ZakazkaNoveVozidloSelect',
	components: {
		NoveVozidloSelect: SkladNovychVozu.components.Select,
	},
	props: {
		storeUri: { type: String, default: null, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers(): Record<string, string> {
			return {
				mutationName: `${this.storeUri}/${types.mutations.ZAKAZKA_NV_SELECT_MAPPER}`,
			};
		},
		actionsMapper(): Record<string, string> {
			return {
				actionName: `${this.storeUri}/${types.actions.ZAKAZKA_NV_CHANGE}`,
			};
		},
		montazDvFilter(): Object {
			return {
				MontazDV: true,
			};
		},
	},
});
